/**
 * Display helpers shared by the users table and a user's detail page.
 *
 * Extracted so the two screens cannot drift — the same person must not be labelled "Coach" on one
 * and "user" on the other, and a date must not be formatted two ways.
 */

export const roleLabel = (role: string): string =>
  role === "admin"
    ? "Organization admin"
    : role === "system_admin"
      ? "Platform admin"
      : "Coach";

/**
 * A plain date. The exact time is not what an admin is scanning for, and rendering in the viewer's
 * locale means a UTC midnight can land on the previous day — which is correct for them.
 */
export const formatUserDate = (iso: string | null): string => {
  if (!iso) return "Never";
  const date = new Date(iso);
  return Number.isNaN(date.getTime())
    ? "Unknown"
    : date.toLocaleDateString(undefined, {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
};
